import StatusIcon from "app/components/Icons/StatusIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonStatusSelection from "app/containers/Features/components/CommonStatusSelection";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGroupDefaultTicketFields } from "../../helpers";
import { GroupByTypeEnum } from "../../types";
import { selectDraftBoardForm } from "../Settings/redux/selector";
import { TicketGroup } from "../../containers/Tickets/types";

interface TicketStatusButtonProps {
  status: string;
  setValue: (val: string) => void;
  defaultGroup: TicketGroup;
  onOpen: () => void;
  onClose: () => void;
}
export const TicketStatusButton: FC<TicketStatusButtonProps> = ({
  status,
  setValue,
  defaultGroup,
  onClose,
  onOpen,
}) => {
  const [selectedData, setSelectedData] = useState<ITicketStatus | null>(null);
  const statusData = useSelector(selectTicketStatus);
  const boardFormData = useSelector(selectDraftBoardForm);
  const handleSelect = (data: ITicketStatus) => {
    setSelectedData(data);
    setValue(data?._id);
  };
  useEffect(() => {
    if (status) {
      const selected = statusData.find((x) => x._id === status);
      setSelectedData(selected as ITicketStatus);
      setValue(selected?._id as string);
    }
    return () => {};
  }, [status]);

  useEffect(() => {
    if (!statusData?.length) return;
    let defaultId = statusData[0]?._id;
    if (boardFormData.groupBy === GroupByTypeEnum.STATUS && defaultGroup) {
      const resolved = getGroupDefaultTicketFields(
        defaultGroup,
        GroupByTypeEnum.STATUS
      );
      const match = statusData.find((s) => s.name === resolved.status);
      if (match) defaultId = match._id;
    }
    setValue(defaultId);
  }, [statusData]);

  return (
    <CommonStatusSelection
      trigger={
        <button className="flex flex-row items-center h-[28px] px-[6px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2] hover:border-[#E9ECF2] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max ">
          <CustomTooltip text="Set status" position="bottom">
            <div className="flex items-center gap-1 min-w-[16px]">
              {<StatusIcon color={selectedData?.color} />}
              {selectedData && (
                <span
                  className="text-sm"
                  style={{ color: selectedData?.color }}
                >
                  {selectedData?.name}
                </span>
              )}
            </div>
          </CustomTooltip>
        </button>
      }
      align="start"
      setValue={handleSelect}
      value={status}
      isHeader="STATUSES"
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
